import * as React from 'react';

const no_results = require('../../media/empty-table.svg');
import { styled } from '../theme';

export interface EmptyItemsWidgetProps {
  label: string;
}

export const EmptyItemsWidget: React.FC<EmptyItemsWidgetProps> = (props) => {
  return (
    <S.EmptyContainer>
      <S.Image src={no_results} />
      <S.EmptyDesc>{props.label || 'No items to display'}</S.EmptyDesc>
    </S.EmptyContainer>
  );
};
namespace S {
  export const EmptyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  `;

  export const Image = styled.img`
    width: 50px;
    margin-bottom: 10px;
  `;

  export const EmptyDesc = styled.div`
    color: ${(p) => p.theme.text.primary};
    font-size: 14px;
  `;
}
